import { HttpApiEndpoint, HttpApiGroup, OpenApi } from "@effect/platform";
import { AppUserId, DeviceId } from "@open-revenue/schema/identifiers";
import { InternalServerError, NotFound, Unauthorized } from "@superwall/api-schema-utils";
import { ApplicationId, ProjectId } from "@superwall/drizzle/branded";
import { Schema } from "effect";
import { Authn } from "../authn";
const ManualEntitlementGrantSchema = Schema.Struct({
    id: Schema.Number,
    applicationId: ApplicationId,
    appUserId: Schema.NullishOr(AppUserId.Schema),
    deviceId: DeviceId.FromOptionallyPrefixedString,
    entitlementId: Schema.String,
    grantedBy: Schema.String,
    grantedAt: Schema.DateTimeUtc,
    expiresAt: Schema.optional(Schema.DateTimeUtc),
    reason: Schema.optional(Schema.String),
    revokedBy: Schema.optional(Schema.String),
    revokedAt: Schema.optional(Schema.DateTimeUtc),
    isActive: Schema.Boolean
});
const EntitlementsV1 = HttpApiGroup.make("entitlementsv1").add(HttpApiEndpoint.post("grantManualEntitlement", "/grant").setPayload(Schema.Struct({
    projectId: ProjectId,
    appUserId: Schema.NullishOr(AppUserId.Schema),
    deviceId: DeviceId.FromOptionallyPrefixedString,
    entitlementId: Schema.String,
    expiresAt: Schema.optional(Schema.Number),
    reason: Schema.optional(Schema.String)
})).addSuccess(Schema.Struct({
    id: Schema.Number
})).addError(NotFound).addError(Unauthorized).addError(InternalServerError).annotate(OpenApi.Summary, "Grant Manual Entitlement").annotate(OpenApi.Description, "Manually grant an entitlement to a user or device")).add(HttpApiEndpoint.post("revokeManualEntitlement", "/revoke").setPayload(Schema.Struct({
    grantId: Schema.Number,
    projectId: ProjectId
})).addSuccess(Schema.Struct({
    success: Schema.Literal(true)
})).addError(NotFound).addError(Unauthorized).addError(InternalServerError).annotate(OpenApi.Summary, "Revoke Manual Entitlement").annotate(OpenApi.Description, "Revoke a previously granted manual entitlement")).add(HttpApiEndpoint.post("listManualEntitlements", "/list").setPayload(Schema.Struct({
    projectId: ProjectId,
    appUserId: Schema.optional(AppUserId.Schema),
    deviceId: Schema.optional(DeviceId.FromOptionallyPrefixedString),
    includeExpired: Schema.optional(Schema.Boolean),
    includeRevoked: Schema.optional(Schema.Boolean)
})).addSuccess(Schema.Array(ManualEntitlementGrantSchema)).addError(NotFound).addError(Unauthorized).addError(InternalServerError).annotate(OpenApi.Summary, "List Manual Entitlements").annotate(OpenApi.Description, "List all manual entitlement grants for an application")).prefix("/v1/entitlements").middleware(Authn);
export default EntitlementsV1;
